import { ForwardedRef, useRef } from "react";

export type RefType<T> = ForwardedRef<T>;

export const updateRef = <T>(ref: RefType<T>, value: T | null) => {
  if (ref == null) return;
  if (typeof ref === "function") {
    ref(value);
    return;
  }

  ref.current = value;
};

export const useWrapRef = <T>(
  ref: ForwardedRef<T>,
  initialValue: T,
): React.MutableRefObject<T> => {
  const internalRef = useRef<T>(initialValue);

  return {
    get current() {
      return internalRef.current;
    },
    set current(value) {
      updateRef(ref, value);
      internalRef.current = value;
    },
  };
};
